import React, { Children } from "react"
import { toNumber } from "lodash"
import PropTypes from "prop-types"

import { LegendContainer, RoundLegend, MainLabel, Legend } from "../index.style.js"

const Legende = ({
  legendValue,
  labelWeight,
  bulletColor,
  labelColor,
  labelSize,
  mainLabel,
  isMobile,
  mapVue,
}) => (
  <LegendContainer id="legende_container" isMobile={isMobile}>
    {mainLabel !== "" && (
      <MainLabel
        className="main_label"
        labelWeight={labelWeight}
        labelSize={labelSize}
        labelColor={labelColor}
      >
        {mainLabel?.toUpperCase()}
      </MainLabel>
    )}
    <div className="legend">
      {Children.toArray(
        legendValue.map(legend => (
          <div className="legend_item">
            {(() => {
              switch (mapVue) {
                case "bckgrColor":
                  return <Legend bckgColor={legend?.color} />
                case "bullet":
                  return (
                    <RoundLegend
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="25px"
                      height="25px"
                    >
                      <g>
                        <circle
                          fill={bulletColor || "#ECECEC"}
                          cx={12.5}
                          cy={12.5}
                          r={legend?.radius}
                        />
                      </g>
                    </RoundLegend>
                  )
                default:
                  return <Legend bckgColor={legend?.color} />
              }
            })()}
            {legend?.name}
          </div>
        ))
      )}
    </div>
  </LegendContainer>
)

Legende.propTypes = {
  labelWeight: PropTypes.string,
  bulletColor: PropTypes.string,
  labelColor: PropTypes.string,
  legendValue: PropTypes.array,
  mainLabel: PropTypes.string,
  labelSize: PropTypes.string,
  isMobile: PropTypes.bool,
  mapVue: PropTypes.string,
}

Legende.defaultProps = {
  labelWeight: "",
  bulletColor: "",
  legendValue: [],
  labelColor: "",
  mainLabel: "",
  labelSize: "",
  isMobile: false,
  mapVue: "",
}

export default Legende
